import { DEFAULT_COUNTRY_CODE } from "@/shared/constants/common.constants";
import { isUceCountryCode } from "@/shared/utils/route.util";
import { parseCookies } from "nookies";

const SIGNUP_VERSION_COOKIE = "signupVersion";

export const useSignupPageSetup = () => {
  const cookies = parseCookies();

  const existingVersion = cookies?.[SIGNUP_VERSION_COOKIE] as "v1" | "v2" | undefined;
  const countryCode = cookies?.countryCode || DEFAULT_COUNTRY_CODE;
  const isUCECountry = isUceCountryCode(countryCode);

  const signupVersion: "v1" | "v2" = (() => {
    if (isUCECountry) return "v2";
    if (existingVersion === "v1" || existingVersion === "v2") return existingVersion;

    const assigned: "v1" | "v2" = Math.random() < 0.5 ? "v1" : "v2";

    if (typeof document !== "undefined" && !cookies?.[SIGNUP_VERSION_COOKIE]) {
      const maxAge = 60 * 60 * 24 * 30; // 30 days
      document.cookie = `${SIGNUP_VERSION_COOKIE}=${assigned}; path=/; max-age=${maxAge}; SameSite=Lax`;
    }

    return assigned;
  })();

  return { signupVersion };
};